import { axiosInstance } from '../config/axiosConfig';
import { API_ENDPOINTS } from '../endpoints/endpoints';

// ── Types ────────────────────────────────────────────────────────────────────

export interface VehicleFeature {
  id: number;
  name: string;
  category?: string;
  sortOrder?: number;
  isActive?: boolean;
  createdAt?: string;
}

export interface CreateVehicleFeatureRequest {
  name: string;
  category?: string;
  sortOrder?: number;
}

export interface UpdateVehicleFeatureRequest {
  name?: string;
  category?: string;
  sortOrder?: number;
  isActive?: boolean;
}

// ── Service ──────────────────────────────────────────────────────────────────

export const vehicleFeatureService = {
  async getFeatures(category?: string): Promise<VehicleFeature[]> {
    const { data } = await axiosInstance.get(API_ENDPOINTS.VEHICLE_MANAGEMENT.FEATURES, {
      params: category ? { category } : undefined,
    });
    return data?.data ?? data;
  },

  async createFeature(payload: CreateVehicleFeatureRequest): Promise<VehicleFeature> {
    const { data } = await axiosInstance.post(API_ENDPOINTS.VEHICLE_MANAGEMENT.FEATURES, payload);
    return data?.data ?? data;
  },

  async deleteFeature(id: number): Promise<{ deleted: number }> {
    const { data } = await axiosInstance.delete(API_ENDPOINTS.VEHICLE_MANAGEMENT.FEATURE_BY_ID(id));
    return data?.data ?? data;
  },
};
